import { useEffect } from 'react';
import numeral from 'numeral';

const InitNumeral = () => {
  useEffect(() => {
    numeral.register('locale', 'en+', {
      delimiters: {
        thousands: ',',
        decimal: '.'
      },
      abbreviations: {
        thousand: 'k',
        million: 'million',
        billion: 'b',
        trillion: 't'
      },
      ordinal(number) {
        const b = number % 10;
        return ~~((number % 100) / 10) === 1
          ? 'th'
          : b === 1
          ? 'st'
          : b === 2
          ? 'nd'
          : b === 3
          ? 'rd'
          : 'th';
      },
      currency: {
        symbol: '$'
      }
    });

    numeral.register('locale', 'pt+', {
      delimiters: {
        thousands: '.',
        decimal: ','
      },
      abbreviations: {
        thousand: 'mil',
        million: 'milhoes',
        billion: 'b',
        trillion: 't'
      },
      ordinal(number) {
        const b = number % 10;
        return ~~((number % 100) / 10) === 1
          ? 'th'
          : b === 1
          ? 'st'
          : b === 2
          ? 'nd'
          : b === 3
          ? 'rd'
          : 'th';
      },
      currency: {
        symbol: '$'
      }
    });
  }, []);
  return null;
};

export default InitNumeral;
